<template>
  <div class="container-resizer flex flex-grow" v-bind="$attrs">
    <VCollapsible v-if="enableLeftCollapse" collapse-direction="left">
      <div ref="leftSideSlot" class="flex">
        <slot name="leftSide" />
      </div>
    </VCollapsible>
    <div v-else ref="leftSideSlot" class="flex">
      <slot name="leftSide" />
    </div>
    <div v-if="showLeftSide" class="resizer -mr-1" @mousedown="mouseDownHandler(true, $event)" />
    <div class="flex flex-grow">
      <slot name="content" />
    </div>
    <div v-if="showRightSide" class="resizer -ml-1" @mousedown="mouseDownHandler(false, $event)" />
    <VCollapsible v-if="enableRightCollapse" collapse-direction="right">
      <div ref="rightSideSlot" class="flex h-full">
        <slot name="rightSide" />
      </div>
    </VCollapsible>
    <div v-else ref="rightSideSlot" class="flex h-full">
      <slot name="rightSide" />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  enableLeftCollapse: {
    type: Boolean,
    default: false,
  },
  enableRightCollapse: {
    type: Boolean,
    default: false,
  },
})

const slots: any = useSlots()
const leftSideSlot = ref()
const rightSideSlot = ref()

let currentSide: HTMLElement | undefined
let currentWidth = 0
let positionX = 0

const mouseDownHandler = (isLeft: boolean, e: MouseEvent) => {
  e.preventDefault()
  e.stopPropagation()

  currentSide = isLeft ? leftSideSlot.value?.children[0] : rightSideSlot.value?.children[0]
  if (!(currentSide instanceof HTMLDivElement)) return

  currentWidth = currentSide?.getBoundingClientRect?.()?.width ?? 0
  positionX = e.clientX

  document.body.classList.add('is-dragging')
  currentSide.classList?.add('pointer-events-none')
  document.addEventListener('mousemove', mouseMoveHandler)
  document.addEventListener('mouseup', mouseUpHandler)
}

const mouseMoveHandler = function (e: MouseEvent) {
  if (!currentSide) return

  let dx = e.clientX - positionX
  if (currentSide === leftSideSlot.value?.children[0]) dx *= -1
  currentSide.style.width = `${currentWidth - dx}px`
}

const mouseUpHandler = function () {
  if (!currentSide) return

  document.body.classList.remove('is-dragging')
  currentSide.classList?.remove('pointer-events-none')
  document.removeEventListener('mousemove', mouseMoveHandler)
  document.removeEventListener('mouseup', mouseUpHandler)
  currentSide = undefined
  currentWidth = 0
}

const showLeftSide = computed(() => slots.leftSide?.())
const showRightSide = computed(() => slots.rightSide?.())
</script>

<style lang="stylus">
.is-dragging
  @apply select-none
  cursor col-resize
  *
    cursor inherit !important
</style>

<style lang="stylus" scoped>
.resizer
  @apply w-1 z-10
  cursor ew-resize
</style>
